import React from 'react';

import { Form } from 'antd';
import { Input, InputGroup, Icon } from 'rsuite';
import Cache from '../../frame/Cache';

import Config from '../../config/Config'
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetModal from '../../widget/WidgetModal';
import WidgetTable from '../../widget/WidgetTable';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetComponent from './../../widget/WidgetComponent';
import WidgetTips from '../../widget/WidgetTips';

import 'antd/dist/antd.css';
import './css/system.css'

class User extends WidgetComponent
{
    constructor( props )
    {
        super(props);

        let path = Config.getBasePath();

        if( path.endsWith('/')===false )
        {
            path = path + '/';
        }

        let userInfo = sessionStorage.getItem("_user_info_");

        if( userInfo!==undefined && userInfo!==null )
        {
            userInfo = JSON.parse(userInfo);
        }

        this.state = {
            userInfo:userInfo,
            path : path,
            keyWord : undefined,
            data : undefined,
            total : undefined,
            userstate:{},
            options : {
                records : 10
            },
            columns:[
                { name: 'UID', title: '用户UID', type: 'string', description: '用户UID', properties: { hidden: true }},
                { name: 'username', title: '用户名', type: 'string', description: '用户名', properties: { hidden: false }},
                { name: 'realname', title: '用户真实姓名', type: 'string', description: '用户真实姓名', properties: { hidden: false }},
                { name: 'cell', title: '手机号码', type: 'string', description: '手机号码', properties: { hidden: false }},
                { name: 'email', title: '电子邮箱', type: 'string', description: '电子邮箱', properties: { hidden: false }},
                { name: 'remark', title: '用户备注', type: 'string', description: '用户备注', properties: { hidden: false }},
                { name: 'operation', title: '操作', type: 'string', description: '操作', 
                    properties: {hidden: false, width:25,
                        operations: [
                            { name: '配额管理', type:"icon", click: "quota", img:"quota" },
                            { name: '修改信息', type:"icon", click: "EditUser", img:"EditUser" },
                            { name: '重置密码', type:"icon", click: "resetPassword", img:"resetPassword"},
                            { name: '启用', type:"icon", click: "enable", img:"enable" },
                            { name: '停用', type:"icon", click: "disable", img:"disable" },
                            { name: '删除', type:"icon", click: "removeDate", img:"remove"},
                        ],transform:"transformOperations"
                    }
                },
            ],
            editDepartmentModelOptions:
            {
              title:'新增用户',
              confirm : "确定",
            },
            quotaOptions:{
                title:'配额管理',
                confirm:'确定'
            },
            layout : 
            {
                labelCol: { span: 6 },
                wrapperCol: { span: 16 },
            },
            messageOptions : 
            {
              title : "重置密码",
              name:'启用',
            },
            resetpwd:
            {

            },
            removeUser : 
            {
              title : "删除用户",
            },
            workQuotar:undefined,
            quotaData:[],
            pageIndex:1
        };
        
        

        this.reset=this.reset.bind(this);
        this.removeDate=this.removeDate.bind(this);
        this.enable=this.enable.bind(this);
        this.onreset=this.onreset.bind(this);
        this.disable=this.disable.bind(this);
        this.onEvent = this.onEvent.bind(this);
        this.onEnable=this.onEnable.bind(this);
        this.ondisable=this.ondisable.bind(this);
        this.enableUser=this.enableUser.bind(this);
        this.removeUser=this.removeUser.bind(this);
        this.disableUser=this.disableUser.bind(this);
        this.userSearch = this.userSearch.bind(this);
        this.onremoveUser=this.onremoveUser.bind(this);
        this.pageTurning = this.pageTurning.bind(this);
        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.resetpassword=this.resetpassword.bind(this);
        this.inputOnchange=this.inputOnchange.bind(this);
        this.onUserSearch = this.onUserSearch.bind(this);
        this.keyWordOnChange = this.keyWordOnChange.bind(this);
        this.transformOperations = this.transformOperations.bind(this);
        this.quota = this.quota.bind(this);
        this.quotaManager = this.quotaManager.bind(this);
        
        this.EditUser = this.EditUser.bind(this);
        this.createUser = this.createUser.bind(this);
        this.onLoadQuota = this.onLoadQuota.bind(this);
        this.onQuotaManager = this.onQuotaManager.bind(this);
    }

  

    componentDidMount()
    {
        this.userSearch(1);
    }

    //  change事件
    inputOnchange( value, type, item)
    {
      switch( type )
      {
          case "username":
          {
              this.state["username"] = value;
              break;
          }
          case "realname":
          {
              this.state["userrealname"] = value;
              break;
          }
          case "call":
            {
                this.state["usercall"] = value;
                break;
            }
            case "email":
            {
                this.state["useremail"] = value;
                break;
            }
            case "remark":
            {
                this.state["userremark"] = value;
                break;
            }
            case 'quota':
                item.REMAIN = Number(value)
                if(Number(value)>item.LIMIT) {
                    item.isTip=true
                }else {
                    item.isTip=false
                }
                this.setState({
                    ...this.state.quotaData,
                    ...item
                })
                break;
          default:
              break;
      }
    }

  /**
     * 表格点击事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
    onEvent(type, data, value, event)
    {
        if( data!==undefined && type!=='transformOperations' )
        {
            data = JSON.parse(data);
        }
       
        switch( type )
        {
            case 'quota':
            {
                this.quota(data);
                break;
            } 
            case "EditUser":
            {
                this.EditUser(data)
                break;
            }
            case "resetPassword":
            {
                this.resetpassword(data)
                break;
            }
            case "enable":
            {
                this.enable(data)
                break;
            }
            case "disable":
            {
                this.disable(data)
                break;
            }
            case "removeDate":
            {
              this.removeDate(data)
                break;
            }
            case 'quota':
                this.quota(data);
                break;
            case 'transformOperations':
            {
                return this.transformOperations(data,value);
            }
                
            default:
                break;
        }
    }

    transformOperations(data,content)
    {
        if( content.props!==undefined && content.props.children!==undefined )
        {
            for( let i=0; i<content.props.children.length; i++ )
            {
                let child = content.props.children[i];

                if( child.props.className==="enable" )
                {
                    if( data.state===1 )
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if( child.props.className==="disable" )
                {
                    if( data.state!==1 )
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
            }
        }
        return content;
    }

    componentDidCatch()
    {
      this.userSearch(1)
    }

    //配额管理
    quota(data)
    {
        this.quotaModelRef.open();
        let { path } = this.state;

        WidgetAjax.ajax({url: path + "user/quota", params: {UID:data.UID} , callback: this.onLoadQuota});
        this.state["resetpwd"]=data

    }
    onLoadQuota( result )
    {
        this.setState({
            quotaData:[],
        })
        if( result.status===0 )
        {
            this.setState({
                quotaData:result.results,
            })
        }
        else if( result.status===10 ) 
        {
            Cache.logout(this.props);
        }
        else
        {
            this.setState({
                quotaData:[{TYPE:1},{TYPE:2},{TYPE:3}],
            })
        }
    }
    quotaModelRef=(ref)=>
    {
      this.quotaModelRef=ref
    }

    quotaManager(){
        let { path, quotaData, resetpwd } = this.state;
        let isTip = quotaData.some(item=>{
            return item.isTip
        })
        let paramData=[]
        quotaData.map(item=>{
            paramData.push({TYPE:item.TYPE,QUOTA:item.REMAIN})
        })
        if(isTip) return;
        WidgetAjax.ajax({url: path + "user/set_quota", params: {UID:resetpwd.UID,quotas:paramData} , callback: this.onQuotaManager});
    }
    onQuotaManager(result){
        let { messageOptions } = this.state;
        messageOptions["isMessage"] = true;
        messageOptions['title'] = '配额管理';

        if( result.status===0 )
        {
            messageOptions["message"] = '配额设置成功！' ;
            setTimeout(()=>{
                this.messageRef.close();
            },2000)
        }
        else
        {
            messageOptions["message"] = "配额设置失败！" ;
            setTimeout(()=>{
                this.messageRef.close();
            },2000)
        }
        this.state["messageOptions"] = messageOptions;
        this.messageRef.open();
    }

    // 启用
    enable(data)
    {
        let {messageOptions}=this.state
        messageOptions["isMessage"] = false ;
        messageOptions["message"]=`您确定要启用${data.username}吗?`
        messageOptions["confirmFunction"]=this.enableUser
        messageOptions["title"]='启用用户'
        this.state["resetpwd"]=data
        this.state["messageOptions"]=messageOptions
        this.messageRef.open()
    }

    // 启用的确认函数
    enableUser()
    {
      const { path, resetpwd } = this.state;
  
      if( resetpwd!==undefined )
      {
          let params = {
              UID : resetpwd.UID
          }
  
          WidgetAjax.ajax({url:path + 'user/resume', params:params, callback:this.onEnable});
      }
    }

    onEnable(result, params)
    {
        let {messageOptions} = this.state
        messageOptions["isMessage"] = true ;

        if(result.status===0)
        {
            messageOptions["message"]='启用成功';
            this.setState({messageOptions},()=>{
                this.messageRef.open();
            })
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
        // 更新页面数据
        this.setState({
            messageOptions
        })
        
        setTimeout(()=>{
            window.location.reload();
        },1300)
    }

    // 停用
    disable(data)
    {
        let {messageOptions}=this.state;

        messageOptions["isMessage"] = false ;

        messageOptions["message"]=`您确定停用${data.username}吗?`;

        messageOptions["confirmFunction"]=this.disableUser;

        this.state["resetpwd"]=data;

        messageOptions["title"]='停用用户';

        this.state["messageOptions"]=messageOptions;

        this.messageRef.open()
    }

    // 停用的confirm方法
    disableUser()
    {
      const { path, resetpwd } = this.state;
  
      if( resetpwd!==undefined )
      {
          let params = {
              UID : resetpwd.UID
          }
  
          WidgetAjax.ajax({url:path + 'user/suspend', params:params, callback:this.ondisable});
      }
    }
    
    // confirm的回调
    ondisable(result, params)
    {
        let { messageOptions } = this.state;
        messageOptions["isMessage"] = true ;

        if(result.status===0)
        {
            messageOptions["message"]='停用成功';
            this.setState({messageOptions},()=>{
                this.messageRef.open();
            })
            
        }
        // 更新页面数据
        this.setState({
            messageOptions
        })
        
        setTimeout(()=>{
            window.location.reload();
        },1300)
    }


    // 新增和编辑的弹框
    editDepartmentModelRef=(ref)=>
    {
        this.state["isCreate"] = false;
        this.editDepartmentModelRef=ref;
    }

    // 信息弹框
    messageRef = ( ref ) => 
    {
        this.messageRef = ref;
    }

    /**
     * 搜索关键字变化回调函数 
     * @param {*} value 
     * @param {*} event 
     */
    keyWordOnChange(value, event)
    {
        this.setState({keyWord:value});
    }

    /**
     * 键盘事件捕获
     * @param {*} e 
     */
    keyWordKeyUp( e )
    {
        /** 判断是否是回车事件 */
        if( e.keyCode===13 )
        {
            this.userSearch();
        }
    }

    /**
     * 用户搜索函数
     */
    userSearch( page )
    {
        const { path, keyWord, options, pageIndex, userInfo} = this.state;

        if( page===undefined )
        {
            page = 1;
        }

        let params = {
            page : page,
            records : options.records
        };

        if(userInfo.realmId !== undefined && userInfo.realmId !== null && userInfo.realmId !== "")
        {
            params["realm_id"] = userInfo.realmId;
        }

        if( keyWord!==undefined && keyWord !== null && keyWord !== "")
        {
            params["name"] = keyWord;
        }

        WidgetAjax.ajax({url:path + 'user/search', params:params, callback:this.onUserSearch});
        this.setState({page:page})
    }

    /**
     * 用户搜索回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onUserSearch( result, params )
    {
        let { pageIndex } = this.state
        if( result.status===0 )
        {   
            if(result.results.length != 0)
            {
                this.setState({data:result.results, total:result.total });
            }
            else
            {
                this.userSearch(pageIndex - 1)
                this.setState({pageIndex:pageIndex - 1
                })
            }
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 表格翻页
     * @param {*} page 
     */
    pageTurning( page )
    {
        this.userSearch(page);
    }


    createUser()
    {
        this.props.history.push({pathname:"/home/userCreate", state:{isCreate:true}});
    }

    EditUser( data )
    {
        this.props.history.push({pathname:"/home/userCreate", state:{isCreate:false, user:data}});
    }

    // 重置密码
    resetpassword( data )
    {

        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false ;
        messageOptions["message"] = `重置密码 '` + data.username +`' 吗? ` ;
        messageOptions["confirmFunction"] = this.reset;
        
        this.state["resetpwd"] = data;

        this.state["messageOptions"] = messageOptions;


        this.messageRef.open();
    }

    // 重置密码确认函数
    reset()
    {
        const { path, resetpwd } = this.state;

        if( resetpwd!==undefined )
        {
            let params = {
                UID : resetpwd.UID
            }
    
            WidgetAjax.ajax({url:path + 'user/reset_password', params:params, callback:this.onreset});
        }
    }

    onreset(result, params)
    {
        let  {messageOptions,} = this.state;
        messageOptions["isMessage"] = true ;

        if( result.status===0 )
        {
                messageOptions["message"]='重置成功！';
                this.setState({messageOptions},()=>{
                    this.messageRef.open();
                })

            // 更新页面数据
            this.setState({
                messageOptions
            })
            
            setTimeout(()=>{
                window.location.reload();
            },1300)
        }
        else
        {
                messageOptions["message"]='重置成功！';
                messageOptions["title"] = "重置密码";
                this.setState({messageOptions},()=>{
                    this.messageRef.open();
                })
                
            // 更新页面数据
            this.setState({
                messageOptions
            })
            
            setTimeout(()=>{
                window.location.reload();
            },1300)
        }

        
    }

    // 删除
    removeDate(data)
    {

        let { messageOptions } = this.state;
        // 控制确定按钮是否显示
        messageOptions["isMessage"] = false ;
        messageOptions["message"] = `确定删除 '` + data.username +`' 吗? ` ;
        messageOptions["confirmFunction"] = this.removeUser;
        this.state["resetpwd"] = data;
        messageOptions["title"]='删除用户'
        this.state["messageOptions"] = messageOptions;

        
        this.messageRef.open();
    }

    // 删除确定按钮回调
    removeUser()
    {
        const { path, resetpwd } = this.state;

        if( resetpwd!==undefined )
        {
            let params = {
                UID : resetpwd.UID
            }

            WidgetAjax.ajax({url:path + 'user/remove', params:params, callback:this.onremoveUser});
        }
    }
    
    onremoveUser(result, params)
    {
        let  { messageOptions, pageIndex } = this.state;   
        messageOptions["title"] = "删除用户";
        messageOptions["isMessage"] = true;

        if( result.status === 0 )
        {
            messageOptions["message"]='删除成功！';
                this.setState({messageOptions},()=>{
                    this.messageRef.open();
                })
                
            // 更新页面数据
            this.setState({
                messageOptions
            })
            
            setTimeout(()=>{
                window.location.reload();
            },1300)
        }
        else
        {
            // message弹框内容
            messageOptions["message"]='删除失败！';
            this.setState({messageOptions},()=>{
                this.messageRef.open();
            })
            
            // 更新页面数据
            this.setState({
                messageOptions
            })
            
            setTimeout(()=>{
                window.location.reload();setTimeout(()=>{
                window.location.reload();
            },1300)
            },1300)
        }
        
    }

    render()
    {
        const {userstate, columns, data, total, keyWord, options, layout,editDepartmentModelOptions,messageOptions,quotaOptions,quotaData,page} = this.state;
        // editDepartmentModelOptions["confirmFunction"] 他的confirm确定函数为submitDepartment
        editDepartmentModelOptions["confirmFunction"] = this.submitUser;
        quotaOptions['confirmFunction']=this.quotaManager;
        return (
            <div className="page user-page page-overflow">
                <div className="page-content" style={{height:"100%",borderRadius:"0",boxShadow:"none"}}>
                    <div className="content-canvas content-top-frame-height height-100"  style={{borderRadius:"0",boxShadow:"none"}}>
                        <div className="content-title Addroles content-title-addroles">
                            <div className="button" onClick={this.createUser}>
                                <span className="addUser click">新增用户</span>
                            </div>
                            <div className="search">
                                <InputGroup className="InputGroup"  >
                                    <Input name="Serchkey" id="input-user" defaultValue={keyWord} placeholder="请输入关键词进行搜索" onChange={this.keyWordOnChange } onKeyUp={this.keyWordKeyUp} />
                                    <InputGroup.Addon><Icon icon="search" onClick={this.userSearch} /></InputGroup.Addon>
                                </InputGroup>
                            </div>
                        </div>

                        <div className="content-chart-height content-table">
                            <WidgetTable tableRowHight={55} options={options} columns={columns} page={page} data={data} total={total} notify={this.onEvent} pageTurning={this.pageTurning} source="./img/icon/"></WidgetTable>
                        </div>
                        </div>
                        <WidgetModal options={editDepartmentModelOptions} onRef={this.editDepartmentModelRef} >
                            <Form  {...layout} name="basic">
                            
                                <Form.Item label="用户名" name="username">
                                    <Input defaultValue={userstate.username} onChange={(value) => {this.inputOnchange(value, "username")}}></Input>
                                </Form.Item>
                                <Form.Item label="用户姓名" name="realname">
                                    <Input defaultValue={userstate.realname} onChange={(value) => {this.inputOnchange(value, "realname")}}></Input>
                                </Form.Item><Form.Item label="手机号" name="call">
                                    <Input defaultValue={userstate.cell} onChange={(value) => {this.inputOnchange(value, "call")}}></Input>
                                </Form.Item>
                                <Form.Item label="电子邮箱" name="email">
                                    <Input defaultValue={userstate.email} onChange={(value) => {this.inputOnchange(value, "email")}}></Input>
                                </Form.Item>
                                <Form.Item label="备注" name="remark">
                                    <Input componentClass="textarea" defaultValue={userstate.remark} onChange={(value) => {this.inputOnchange(value, "remark")}}></Input>
                                </Form.Item>
                            </Form>
                        </WidgetModal>
                        <WidgetModal options={quotaOptions} onRef={this.quotaModelRef}>
                            {
                                quotaData.map((item,key)=>{
                                    return <div key={key} className='quota_item'>
                                        <span className='quota_tit'>{item.TYPE===1?'外呼量':item.TYPE===2?'浏览记录':'下载记录'} : </span>
                                        <div className='quota_item_position'>
                                            <Input defaultValue={item.REMAIN} onChange={(value) => {this.inputOnchange(value, "quota",item)}}></Input>
                                            {item.isTip && <span>额度上限为{item.LIMIT}条</span>}
                                        </div>
                                        <span>条，额度上限为 : {item.LIMIT} 条</span>
                                    </div>
                                })
                            }
                        </WidgetModal>
                    </div>
                <WidgetMessage options={messageOptions} onRef={this.messageRef} />
          </div>
        );
    }
}

export default User
